// FILECONTENT_START src/common/components/GlobalMessaging/index.ts
import GlobalMessaging from "./GlobalMessaging";
export default GlobalMessaging;
export { globalMessageHandler } from "./GlobalMessaging";

// FILECONTENT_END src/common/components/GlobalMessaging/index.ts